module.exports = __webpack_public_path__ + "static/media/notification.8072e82b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/notification.mp3
// module id = 464
// module chunks = 56